import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';

import NotFoundPage from 'components/NotFoundPage';

import messages from './messages';

class CaseDetailData extends Component {
  static propTypes = {
    addPageToBreadcrumbs: PropTypes.func.isRequired,
    caseError: PropTypes.shape({
      error: PropTypes.oneOf([true]).isRequired,
    }),
    caseInfo: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    ChildComponent: PropTypes.func.isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: PropTypes.object.isRequired,
    i18n: PropTypes.shape({
      _: PropTypes.func.isRequired,
    }).isRequired,
    loadCase: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    setCurrentCase: PropTypes.func.isRequired,
    setLoadingStarted: PropTypes.func.isRequired,
  };

  static defaultProps = {
    caseError: undefined,
  };

  componentWillMount() {
    const { match: { params: { caseId } } } = this.props;
    this.props.setCurrentCase(caseId);
  }

  componentDidMount() {
    const { match: { params: { caseId } } } = this.props;
    this.props.loadCase(caseId);
    this.props.setLoadingStarted();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.caseInfo.id && nextProps.caseInfo.id) {
      this.props.addPageToBreadcrumbs({
        path: this.props.location.pathname,
        message: messages.breadcrumbs,
        number: nextProps.caseInfo.id,
      });
    }
  }

  componentWillUnmount() {
    this.props.setCurrentCase();
  }

  render() {
    const {
      caseError,
      ChildComponent,
      i18n,
    } = this.props;

    if (caseError) {
      return <NotFoundPage />;
    }

    return (
      <div>
        <Helmet
          title={i18n._(messages.title)}
          meta={[{ name: 'description', content: i18n._(messages.description) }]}
        />
        <ChildComponent {...this.props.componentProps} />
      </div>
    );
  }
}

export default CaseDetailData;



// WEBPACK FOOTER //
// ./containers/CaseDetailData/Component.js